import React from 'react';
import {Helmet} from 'react-helmet';
import {Router} from '@reach/router';

import {PageNav} from 'ui-kit';

import {
  AllMembers,
  MembershipDetail,
  NewMembership,
} from './components';

export class Memberships extends React.Component {
  render() {
    return (
      <div>
        <Helmet title="Memberships" />

        <h1>Memberships</h1>

        <PageNav
          links={[
            {url: './', content: 'All members'},
            {url: '/memberships/new', content: 'New membership'},
          ]}
        />

        <Router primary={false}>
          <AllMembers path="/" />
          <NewMembership path="new" />
          <MembershipDetail path=":id" />
        </Router>
      </div>
    );
  }
}
